import { Link } from "react-router-dom";
import { ShoppingCart, FileDoc } from "@phosphor-icons/react";
import { formatINR, formatDate } from "../../lib/format";
import { cn as classJoin } from "../../lib/utils";
import TimelineNode from "./TimelineNode";

export function PoLane({ po, events, onQuickBill }) {
    const bs = po.billing_status;
    const fullyPaid = bs.fully_paid;
    const fullyInvoiced = bs.fully_invoiced;
    let toneCls = "border-slate-200";
    if (fullyPaid) toneCls = "border-emerald-300 bg-emerald-50/30";
    else if (fullyInvoiced) toneCls = "border-amber-300 bg-amber-50/20";
    else if (po.is_final) toneCls = "border-slate-300";

    return (
        <div className={classJoin("reedos-card", toneCls)} data-testid={`po-lane-${po.id}`}>
            <div className="px-5 py-4 border-b border-slate-200 flex items-start justify-between gap-3 flex-wrap">
                <div className="min-w-0 flex-1">
                    <div className="reedos-eyebrow flex items-center gap-1.5">
                        <ShoppingCart size={11} /> Purchase Order
                        {po.is_final
                            ? <span className="inline-flex items-center gap-0.5 rounded px-1.5 py-0 text-[9px] font-bold border bg-amber-50 text-amber-800 border-amber-200">FINALIZED</span>
                            : <span className="inline-flex items-center gap-0.5 rounded px-1.5 py-0 text-[9px] font-bold border bg-slate-100 text-slate-700 border-slate-300">DRAFT</span>}
                    </div>
                    <Link to={`/purchase-orders/${po.id}`} className="font-mono text-base font-bold text-slate-900 hover:underline">
                        {po.po_number}
                    </Link>
                    <div className="text-[11px] text-slate-500 mt-0.5">
                        {po.from_proposal_number && <>From <Link to={`/proposals/${po.from_proposal_id}`} className="font-mono hover:underline">{po.from_proposal_number}</Link> · </>}
                        Created {formatDate(po.created_date)}
                        {po.finalized_date && <> · Finalized {formatDate(po.finalized_date)}</>}
                    </div>
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 text-right">
                    <Tile label="PO Total" value={formatINR(bs.po_total)} valueClass="text-slate-900" />
                    <Tile label="Invoiced" value={formatINR(bs.invoiced_amount)} valueClass="text-indigo-700" />
                    <Tile label="Received" value={formatINR(bs.received_amount)} valueClass="text-emerald-700" />
                    <Tile label="Balance" value={formatINR(bs.balance_to_invoice)} valueClass={fullyInvoiced ? "text-emerald-700" : "text-amber-700"} />
                </div>
            </div>
            <div className="px-5 py-2">
                {events.length === 0 ? (
                    <div className="text-xs text-slate-400 italic py-3">No lifecycle events yet for this PO.</div>
                ) : (
                    events.map((ev, idx) => (
                        <TimelineNode key={`${ev.type}-${idx}`} ev={ev} last={idx === events.length - 1} onQuickBill={onQuickBill} />
                    ))
                )}
            </div>
        </div>
    );
}

export function StandaloneLane({ events, label }) {
    if (!events?.length) return null;
    return (
        <div className="reedos-card" data-testid={`lane-${label.toLowerCase()}`}>
            <div className="px-5 py-3 border-b border-slate-200">
                <div className="reedos-eyebrow flex items-center gap-1.5"><FileDoc size={11} /> {label}</div>
                <div className="text-[11px] text-slate-500 mt-0.5">{events.length} event{events.length !== 1 ? "s" : ""}</div>
            </div>
            <div className="px-5 py-2">
                {events.map((ev, idx) => (
                    <TimelineNode key={`${ev.type}-${idx}`} ev={ev} last={idx === events.length - 1} />
                ))}
            </div>
        </div>
    );
}

function Tile({ label, value, valueClass }) {
    return (
        <div className="px-2.5">
            <div className="reedos-eyebrow text-[9px]">{label}</div>
            <div className={classJoin("reedos-data text-sm font-bold", valueClass)}>{value}</div>
        </div>
    );
}
